import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

const TooltipContent = (props: {
  status: 'A' | 'I' | 'S';
  email: ReactNode;
  idp: ReactNode;
}) => {
  const { t } = useTranslation();

  const STATUS_LOOKUP = {
    A: t('Active'),
    I: t('Deleted'),
    S: t('Suspended'),
  };

  const status = STATUS_LOOKUP[props.status];

  return (
    <div>
      <div>
        <span className="op-font-weight-500">Email:</span> {props.email}
      </div>
      <div>
        <span className="op-font-weight-500">IDP:</span> {props.idp}
      </div>
      <div>
        <span className="op-font-weight-500">Status:</span> {status}
      </div>
    </div>
  );
};

export default TooltipContent;
